// middleware/auth.global.ts
import { initializeMsalAuth } from '@base/services/msal/auth'
import { getEnvironment } from '@/environments'

export default defineNuxtRouteMiddleware(() => {
  return initializeMsalAuth(getEnvironment)
})
